(() => {
  // Refresh cart sections so "Estimated total" updates instantly
  async function refreshCartSections() {
    const sections = ['main-cart-items', 'main-cart-footer'];

    const res = await fetch(`/cart?sections=${sections.join(',')}`, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });

    if (!res.ok) return;

    const data = await res.json().catch(() => null);
    if (!data) return;

    sections.forEach((handle) => {
      const html = data[handle];
      if (!html) return;

      const existing = document.getElementById(`shopify-section-${handle}`);
      if (!existing) return;

      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      const incoming = tmp.querySelector(`#shopify-section-${handle}`);
      if (incoming && existing.parentNode) {
        existing.parentNode.replaceChild(incoming, existing);
      }
    });
  }

  // Debounce so multiple rapid cart requests only refresh once
  let t = null;
  function scheduleRefresh() {
    clearTimeout(t);
    t = setTimeout(() => refreshCartSections(), 150);
  }

  // 1) Intercept fetch calls to Shopify cart endpoints (most reliable)
  const origFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = (typeof args[0] === 'string') ? args[0] : (args[0]?.url || '');
    const res = await origFetch.apply(this, args);

    // If cart is changed via AJAX, refresh sections
    if (
      url.includes('/cart/change') ||
      url.includes('/cart/add') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    ) {
      // Only refresh if request succeeded
      if (res && res.ok) scheduleRefresh();
    }

    return res;
  };

  // 2) Fallback: if quantity inputs change, refresh shortly after
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!el) return;

    if (el.matches('input[name="updates[]"], .quantity__input')) {
      scheduleRefresh();
    }
  });
})();
